import { SxProps, Theme } from '@mui/material'

export interface Styles {
  [key: string]: SxProps<Theme>
}

declare global {
  interface Window {
    adobeDataLayer: any
  }
}

export type PaymentMethodType = 'BankAccount' | 'CreditCard' | undefined
export const PAYMENT_METHOD = {
  CreditCard: 'CreditCard',
  BankAccount: 'BankAccount',
} as const

export type PayMethodType = keyof typeof PAYMENT_METHOD
